// locales/cs.ts
import { Translations } from '../types/language';

export const csTranslations: Translations = {
  // Header
  appTitle: "🌐 ClipShare",
  appSubtitle: "Multipoint sdílení schránky přes WebRTC",
  
  // Main Menu
  oneTimeSharing: "Jednorázové sdílení",
  oneTimeSharingDesc: "Vytvořte nebo se připojte k dočasné relaci pro sdílení schránky",
  userAccount: "Uživatelský účet",
  userAccountDesc: "Trvalé sdílení s historií a pokročilými funkcemi",
  comingSoon: "Již brzy...",
  
  // Session Setup
  oneTimeSharingTitle: "🚀 Jednorázové sdílení",
  yourNickname: "👤 Vaše přezdívka:",
  enterNickname: "Zadejte svou přezdívku...",
  nicknameDesc: "Tato přezdívka se bude zobrazovat ostatním účastníkům",
  createSession: "📡 Vytvořit relaci",
  joinSession: "🔗 Připojit se",
  clickToCreateCode: "Klikněte pro vytvoření kódu relace",
  createCode: "🎯 Vytvořit kód",
  yourSessionCode: "Váš kód relace",
  shareThisCode: "Sdílejte tento kód s ostatními účastníky",
  copyCode: "📋 Kopírovat kód",
  startChat: "💬 Spustit chat",
  chatAutoOpen: "💡 Chat se automaticky otevře, když se někdo připojí",
  enterSessionCode: "Zadejte kód relace:",
  connect: "🚀 Připojit se",
  paste: "📋 Vložit",
  backToMenu: "← Zpět na hlavní menu",
  
  // Chat Room
  session: "Relace:",
  connected: "Připojeno",
  connecting: "Připojování...",
  disconnected: "Odpojeno",
  unknownStatus: "Neznámý stav",
  participants: "účastníků",
  participant: "účastník",
  you: "To jste Vy",
  leave: "🚪 Opustit",
  
  // Chat Messages
  messagesWillAppear: "💬 Zprávy ze schránky se budou zobrazovat zde",
  clickToCopy: "Klikněte na zprávu pro kopírování do schránky",
  typeMessage: "Napište zprávu...",
  send: "📤 Odeslat",
  
  // Clipboard Monitor
  autoTracking: "🔄 Auto sledování",
  manualChat: "💬 Manuální chat",
  watchingClipboard: "👁️ Sleduje schránku",
  monitoringPaused: "⏸️ Monitoring pozastaven",
  pause: "⏸️ Pozastavit",
  start: "▶️ Spustit",
  manualMode: "💬 Manuální režim - zadávejte zprávy níže",
  
  // Context Menu
  copyAsPlainText: "📄 Kopírovat jako prostý text",
  copyToClipboard: "📋 Kopírovat do schránky",
  downloadImage: "💾 Stáhnout obrázek",
  
  // Alerts
  codeCreated: "Kód relace byl vytvořen!",
  connectedToSession: "Připojeno k relaci!",
  userJoined: "se připojil! Chat spuštěn.",
  chatStarted: "Chat spuštěn! Sdílejte kód s ostatními a čekejte na připojení...",
  allParticipantsLeft: "Všichni účastníci odešli. Čekání na nové připojení...",
  waitingForNew: "Čekání na nové připojení...",
  sessionEnded: "Relace byla ukončena",
  sessionTerminated: "Relace byla ukončena",
  codeCopied: "Kód zkopírován do schránky!",
  failedToCopyCode: "Nepodařilo se zkopírovat kód",
  codeFromClipboard: "Kód vložen ze schránky",
  invalidCodeInClipboard: "Ve schránce není platný kód",
  failedToReadClipboard: "Nepodařilo se načíst ze schránky",
  chatStartedShare: "Chat spuštěn! Sdílejte kód s ostatními a čekejte na připojení...",
  textCopied: "Text zkopírován do schránky!",
  imageCopied: "Obrázek zkopírován do schránky!",
  failedToCopy: "Nepodařilo se zkopírovat obsah",
  textCopiedPlain: "Text zkopírován jako prostý text!",
  imageDownloaded: "Obrázek byl stažen",
  
  // Errors
  serverNotConnected: "Spojení se serverem není aktivní",
  enterValidCode: "Zadejte platný 6místný kód",
  
  // Message types
  image: "Obrázek"
};